$(function () {
  'use strict'
  $('[data-toggle="offcanvas"]').on('click', function () {
    $('.row-offcanvas').toggleClass('active')
  })
})


//////////////////
// WEBPACK FOOTER
// ./static/assets/js/offcanvas.js
// module id = 8hlM
// module chunks = 1